import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { BrandingPanel } from "./BrandingPanel";
import { BrandingPanelV2 } from "./BrandingPanelV2";
import { jsx as _jsx } from "react/jsx-runtime";
export default function BrandingControllers(_ref) {
  let {
    worksAt: _
  } = _ref;
  const {
    BRANDING_IMPROVEMENTS = false
  } = useFeatureFlags();
  if (!BRANDING_IMPROVEMENTS) {
    return /*#__PURE__*/_jsx(BrandingPanel, {});
  }
  return /*#__PURE__*/_jsx(BrandingPanelV2, {});
}